const KEY = 'goss.activeOrgId';

export function getActiveOrgId(): string | null {
  return localStorage.getItem(KEY);
}

export function setActiveOrgId(id: string): void {
  localStorage.setItem(KEY, id);
}
